// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  untilEOL = 210,
  untilCommentClose = 211,
  Program = 1,
  EnableDirective = 2,
  Identifier = 3,
  Directive = 4,
  EnableExtension = 5,
  TypeDeclaration = 6,
  Type = 82,
  Keyword = 194,
  IntLiteral = 37,
  UintLiteral = 38,
  Reserved = 104,
  LocalDeclaration = 105,
  GlobalVariableDeclaration = 106,
  AttributeList = 107,
  Attribute = 108,
  FloatLiteral = 109,
  GlobalVariable = 110,
  VariableQualifier = 112,
  VariableIdentifier = 113,
  Assign = 114,
  Sub = 116,
  Boolean = 118,
  GlobalConstantDeclaration = 119,
  LeftBracket = 125,
  RightBracket = 126,
  FieldAccess = 127,
  PrivateIdentifier = 128,
  Bang = 129,
  Tilde = 130,
  Mul = 131,
  And = 132,
  Div = 133,
  Mod = 134,
  Add = 135,
  Left = 136,
  Right = 137,
  Lt = 138,
  Gt = 139,
  Lte = 140,
  Gte = 141,
  Eq = 142,
  Neq = 143,
  OrOr = 144,
  AndAnd = 145,
  Or = 146,
  Xor = 147,
  TypeAliasDeclaration = 148,
  StructDeclaration = 150,
  StructBodyDeclaration = 152,
  StructMember = 153,
  FunctionDeclaration = 154,
  FunctionHeader = 155,
  ParamList = 157,
  Param = 158,
  ReturnType = 159,
  CompoundStatement = 160,
  Statement = 161,
  ContinuingStatement = 170,
  AddAssign = 174,
  SubAssign = 175,
  MulAssign = 176,
  DivAssign = 177,
  ModAssign = 178,
  AndAssign = 179,
  XorAssign = 180,
  OrAssign = 181,
  LeftAssign = 182,
  RightAssign = 183,
  Inc = 184,
  Dec = 185,
  ImportDeclaration = 189,
  ImportDeclarationList = 191,
  ImportDeclarationIdentifier = 192,
  String = 193
